<template>
    <div class="show-more-wrapper">
        <p v-if="total > 0" class="show-more-status">
            Displaying {{ rangeStart }} - {{ rangeEnd }} (of {{ total }} total results)
        </p>
        <button
            v-if="hasMore"
            type="button"
            class="show-more-btn btn btn-pill"
            :disabled="loading"
            @click="$emit('load-more')"
        >
            {{ loading ? "Loading..." : label }}
        </button>
    </div>
</template>

<script>
export default {
    name: "ShowMore",
    props: {
        loaded: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
        hasMore: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: "Show More",
        },
    },
    computed: {
        rangeStart() {
            return this.loaded > 0 ? 1 : 0;
        },
        rangeEnd() {
            return Math.min(this.loaded, this.total);
        },
    },
};
</script>

<style scoped lang="scss">
.show-more-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.show-more-status {
    margin: 0;
    color: var(--color-mine-shaft, #333);
    font-family: "Acumin Pro", Arial, Helvetica, sans-serif;
    font-size: 0.85rem;
    font-weight: 500;
}

.show-more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 10rem;
    height: 2.75rem;
    padding: 0 1.5rem;
    border: 1px solid #cd1b00;
    background: #cd1b00;
    color: #fff;
    cursor: pointer;
    font-family: "Acumin Pro", Arial, Helvetica, sans-serif;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.show-more-btn:hover:not(:disabled) {
    background: #fff;
    color: #cd1b00;
}

.show-more-btn:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}
</style>
